import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import { withDesktopBreakpoint } from '@Hooks/withBreakpoints/withBreakpoint';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { setCurrentEditor as setCurrentEditorAction, setStructure as setStructureAction } from './actions';
import StructureEditorPage from './StructureEditorPage';

function StructureEditorPageContainer(props) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    const skipLinkFooter = document.getElementById('els-skiplink-footer');
    const footerListItem = skipLinkFooter ? skipLinkFooter.parentElement : null;
    if (footerListItem) {
      footerListItem.style.display = 'none'; // Hide the element that contains the skip link for footer
    }
    return () => {
      if (footerListItem) {
        footerListItem.style.display = ''; // Reset display to show the footer element again
      }
    };
    // eslint-disable-next-line
  }, []);
  return <StructureEditorPage {...props} />;
}
const mapDispatchToProps = (dispatch) => ({
  setCurrentEditor: (editor) => dispatch(setCurrentEditorAction(editor)),
  setStructureToEditor: (newStructure) => dispatch(setStructureAction(newStructure)),
});

export default compose(
  withCombinedRouteParams,
  connect(() => ({}), mapDispatchToProps),
  withDesktopBreakpoint()
)(StructureEditorPageContainer);
